import type { CanvasTheme } from "@/api/openapi/discovery/types.gen";

export function shouldShowThemeDetailMode(group: CanvasTheme): boolean {
  return (group.subthemes?.length ?? 0) === 0 && Boolean(group.text.body?.trim());
}

export function themeDetailQuotes(group: CanvasTheme): string[] {
  return (group.quotes ?? []).map((quote) => quote.text.trim()).filter(Boolean);
}
